export default __webpack_public_path__ + "static/media/nesto_secure_logo_en_mobile.f60406f7.png";